import {
  type DashboardWidgetDirection,
  type DashboardWidgetResolution,
  type DashboardWidgetType,
  type ReportColumnDefinition,
} from '@terros/common'
import { ColorPrimitives, type SelectItem } from '@front/model'

export const WIDGET_TYPE_OPTIONS: SelectItem<DashboardWidgetType>[] = [
  { value: 'number', label: 'Number' },
  { value: 'leaderboard', label: 'Leaderboard' },
  { value: 'line', label: 'Line Chart' },
  { value: 'table', label: 'Table' },
  { value: 'goal', label: 'Goal' },
]

export const WIDGET_TYPE_LABELS: Record<DashboardWidgetType, string> = {
  number: 'Number',
  goal: 'Goal',
  leaderboard: 'Leaderboard',
  line: 'Line Chart',
  table: 'Table',
}
export const RESOLUTION_OPTIONS: SelectItem<DashboardWidgetResolution>[] = [
  { value: 'auto', label: 'Auto' },
  { value: 'hour', label: 'Hour' },
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'quarter', label: 'Quarter' },
  { value: 'year', label: 'Year' },
]
export const DIRECTION_OPTIONS: SelectItem<DashboardWidgetDirection>[] = [
  { value: 'asc', label: 'Ascending' },
  { value: 'desc', label: 'Descending' },
]

/**
 * Line-widget target colors, matching the iOS swatch row exactly (`dashboardThresholdColors`
 * in DashboardWidgetConfigView). The choice is stored as a raw hex shared across platforms,
 * so the two iOS system colors stay as hex even though they have no ColorPrimitive twin.
 */
export const LINE_THRESHOLD_COLORS = [
  ColorPrimitives.blue['600'],
  '#34C759',
  ColorPrimitives.yellow['500'],
  ColorPrimitives.orange['500'],
  '#AF52DE',
]

/** Editor and chart both fall back to this when the widget has no explicit color. */
export const DEFAULT_LINE_THRESHOLD_COLOR = LINE_THRESHOLD_COLORS[0]

export type ColumnGroup = {
  title: string
  columns: ReportColumnDefinition[]
}
